import SeeMoreIconButton from './SeeMoreIconButton';
import type { SeeMoreIconButtonProps } from './SeeMoreIconButton';

export type { SeeMoreIconButtonProps };
export default SeeMoreIconButton;
